module.exports = __webpack_public_path__ + "img/stop_record_icon.929877fe.svg";